import type { GeneratedFile } from '../../../../types/generatedFile';

interface CategorizedFiles {
  docs: GeneratedFile[];
  pdfs: GeneratedFile[];
  csvFiles: GeneratedFile[];
  htmlFiles: GeneratedFile[];
  imageFiles: GeneratedFile[];
  others: GeneratedFile[];
}

const IMAGE_FILE_TYPES = ['jpg', 'jpeg', 'webp', 'png'];
const CATEGORIZED_TYPES = ['docx', 'pdf', 'csv', 'html', ...IMAGE_FILE_TYPES];

function categorizeGeneratedFiles(files: GeneratedFile[]): CategorizedFiles {
  return {
    docs: files.filter(f => f.fileType === 'docx'),
    pdfs: files.filter(f => f.fileType === 'pdf'),
    csvFiles: files.filter(f => f.fileType === 'csv'),
    htmlFiles: files.filter(f => f.fileType === 'html'),
    imageFiles: files.filter(f => IMAGE_FILE_TYPES.includes(f.fileType)),
    others: files.filter(f => !CATEGORIZED_TYPES.includes(f.fileType)),
  };
}

export { categorizeGeneratedFiles };
export type { CategorizedFiles };
